import { useMutation } from 'react-query';

import { apiV1 } from '@global-libs/axios';

import { createUseUserRegister } from './keys';
import { UserRegisterParams } from './types';

export const getRoom = (id: string) => {
  return apiV1.get(`/room?Id=${id}`);
};

const setRegister = (params: UserRegisterParams) => {
  return apiV1.post(`/user/register`, params);
};

export function useUserRegister() {
  return useMutation(createUseUserRegister(), setRegister);
}
